import { render, staticRenderFns } from "./apartments-overview-heading.vue?vue&type=template&id=440b145d&scoped=true&"
import script from "./apartments-overview-heading.ts?vue&type=script&lang=ts&"
export * from "./apartments-overview-heading.ts?vue&type=script&lang=ts&"
import style0 from "./apartments-overview-heading.scss?vue&type=style&index=0&id=440b145d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440b145d",
  null
  
)

export default component.exports